import React, { useLayoutEffect, useRef, useState } from "react";
import Box from "@mui/material/Box";

/** Stripe Climate embed (Dashboard → Climate → badge embed). Native size is 380×38. */
export const STRIPE_CLIMATE_BADGE_IFRAME_SRC =
    "https://climate.stripe.com/badge/TxJiUk?theme=light&size=small&locale=en-US";

const BADGE_W = 380;
const BADGE_H = 38;

/**
 * Keep the badge at Stripe’s native 380×38 layout and scale the wrapper to the container.
 * Squeezing the iframe width wraps Stripe’s page, clips the icon, and shows a scrollbar.
 *
 * @param {object} props
 * @param {import("@mui/material").BoxProps["sx"]} [props.sx] — merged with wrapper styles
 */
export default function StripeClimateBadgeIframe({ sx: sxProp, ...rest }) {
    const wrapRef = useRef(null);
    const [scale, setScale] = useState(1);

    useLayoutEffect(() => {
        const el = wrapRef.current;
        if (!el || typeof ResizeObserver === "undefined") {
            return undefined;
        }
        const apply = () => {
            const w = el.getBoundingClientRect().width;
            if (w <= 0) {
                return;
            }
            setScale(Math.min(1, w / BADGE_W));
        };
        apply();
        const ro = new ResizeObserver(apply);
        ro.observe(el);
        return () => ro.disconnect();
    }, []);

    return (
        <Box
            ref={wrapRef}
            className="climate-badge"
            sx={{
                lineHeight: 0,
                width: "100%",
                maxWidth: BADGE_W,
                minWidth: 0,
                alignSelf: "stretch",
                mx: "auto",
                overflow: "hidden",
                height: BADGE_H * scale,
                ...sxProp,
            }}
            {...rest}
        >
            <Box
                sx={{
                    width: BADGE_W,
                    height: BADGE_H,
                    transformOrigin: "top left",
                    transform: `scale(${scale})`,
                }}
            >
                <iframe
                    src={STRIPE_CLIMATE_BADGE_IFRAME_SRC}
                    title="Stripe Climate commitment"
                    loading="lazy"
                    scrolling="no"
                    width={BADGE_W}
                    height={BADGE_H}
                    style={{
                        border: 0,
                        display: "block",
                        width: BADGE_W,
                        height: BADGE_H,
                        overflow: "hidden",
                    }}
                />
            </Box>
        </Box>
    );
}
